// ------------------------------------------------------------------
// PURE MODULE: alphay_1.mod.js
// ------------------------------------------------------------------
import gsap from "gsap"; 

export function Alphay1(item, index, selector = '.my-custom-element-class') {
    
	    const config = {
       indelay:0.25,
    };
	
    // --- Safety Check ---
    if (!item || !item.image) return;

    // --- Find the custom element ---
    const customElement = item.image.querySelector(selector);
    if (!customElement) return;

    // --- Initial State ---
    gsap.set(customElement, { opacity: 0, y: 50 });

    // --- CUSTOM "FADE IN" ---
    // We attach this to the existing timeline on the item
    if (item.animationState && item.animationState.fadeInTween) {
        item.animationState.fadeInTween.to(
            customElement,
            { opacity: 1, y: 0, duration: 1, ease: 'power2.out' }, 
            indelay // Insert at 0.25s
        );
    }

    // --- CUSTOM "FADE OUT" ---
    if (item.animationState && item.animationState.fadeOutTween) {
        item.animationState.fadeOutTween.to(
            customElement,
            { opacity: 0, y: 50, duration: 1, ease: 'power2.out' }, 
            0 // Insert at 0s
        );
    }
	return { config };
}